export default {
  // GET Request //

  // Gets all events
  async getEvents(context) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER +
          "/events/retrieve-by-company/" +
          companyId,
        {
          method: "GET",
          headers: { Authorization: "Bearer " + token },
        }
      );
      response = await response.json();
    } catch (err) {
      return 500;
    }

    for (let i = 0; i < response.events.length; i++) {
      response.events[i].eventId = response.events[i]._id;
    }

    context.commit("eventsTimestamp");
    context.commit("events", response.events);

    return 200;
  },

  // POST Requests //

  // Create an event
  async postEvent(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(process.env.VUE_APP_NODE_SERVER + "/events/add", {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + token,
        },
        body: JSON.stringify({
          companyId: companyId,
          eventName: payload.eventName,
          eventType: payload.eventType,
          startDatetime: payload.startDatetime,
          endDatetime: payload.endDatetime,
          hosts: payload.hosts,
          description: payload.description,
          audience: payload.audience,
          locations: payload.locations,
          attendees: payload.attendees,
          departments: payload.departments,
          meetingLocationType: payload.meetingLocationType,
          meetingLocation: payload.meetingLocation,
        }),
      });
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    response.event.eventId = response.event._id;

    let eventsPayload = context.state.events;
    eventsPayload.push(response.event);

    context.commit("events", eventsPayload);

    return {
      status: 201,
      eventId: response.event.eventId,
    };
  },

  // PATCH Requests //

  // Update an event
  async patchEvent(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/events/update",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            eventId: payload.eventId,
            eventName: payload.eventName,
            eventType: payload.eventType,
            startDatetime: payload.startDatetime,
            endDatetime: payload.endDatetime,
            hosts: payload.hosts,
            description: payload.description,
            audience: payload.audience,
            locations: payload.locations,
            attendees: payload.attendees,
            departments: payload.departments,
            meetingLocationType: payload.meetingLocationType,
            meetingLocation: payload.meetingLocation,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      console.log(err);
      return { status: 500 };
    }

    response.event.eventId = response.event._id;

    let eventsPayload = context.state.events;
    for (let i = 0; i < eventsPayload.length; i++) {
      if (eventsPayload[i].eventId == response.event.eventId) {
        eventsPayload[i] = response.event;
        break;
      }
    }

    context.commit("events", eventsPayload);

    return {
      status: 200,
      eventId: response.event.eventId,
    };
  },
  // Adds event image
  async patchEventImage(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;
    const fd = new FormData();
    fd.append("file", payload.file, payload.eventId);
    fd.append("eventId", payload.eventId);

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/events/update-event-image",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
      session = await session.json();
    } catch (err) {
      return { status: 500 };
    }

    session.event.eventId = session.event._id;

    let eventsPayload = context.state.events;
    for (let i = 0; i < eventsPayload.length; i++) {
      if (eventsPayload[i].eventId == session.event.eventId) {
        eventsPayload[i] = session.event;
        break;
      }
    }

    context.commit("events", eventsPayload);

    session.status = 200;
    return session;
  },
  // Post and image newsfeed
  async patchAddAttachments(context, payload) {
    const token = context.rootGetters["authData/token"];
    let session;

    const fd = new FormData();
    for (let i = 0; i < payload.attachments.length; i++) {
      fd.append("file", payload.attachments[i]);
    }

    fd.append("eventId", payload.eventId);

    try {
      session = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/events/add-attachments",
        {
          method: "PATCH",
          mode: "cors",
          headers: {
            Authorization: "Bearer " + token,
          },
          body: fd,
        }
      );
      session = await session.json();
    } catch (err) {
      console.log(err);
      return { status: 500 };
    }

    session.event.eventId = session.event._id;

    let eventsPayload = context.state.events;
    for (let i = 0; i < eventsPayload.length; i++) {
      if (eventsPayload[i].eventId == session.event.eventId) {
        eventsPayload[i] = session.event;
        break;
      }
    }

    return { status: 200 };
  },

  // DELETE Requests //

  // Remove an event
  async deleteEvent(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/events/remove",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            eventId: payload.eventId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    let eventsPayload = context.state.events;
    eventsPayload = eventsPayload.filter(
      (event) => event.eventId != payload.eventId
    );

    context.commit("events", eventsPayload);

    return {
      status: 201,
      eventId: response.eventId,
    };
  },
  async deleteEventAttachment(context, payload) {
    const token = context.rootGetters["authData/token"];
    const companyId = context.rootGetters["userData/companyId"];
    let response;

    try {
      response = await fetch(
        process.env.VUE_APP_NODE_SERVER + "/events/remove-attachment",
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          body: JSON.stringify({
            companyId: companyId,
            attachmentId: payload.attachmentId,
            eventId: payload.eventId,
          }),
        }
      );
      response = await response.json();
    } catch (err) {
      return { status: 500 };
    }

    response.event.eventId = response.event._id;

    let eventsPayload = context.state.events;
    for (let i = 0; i < eventsPayload.length; i++) {
      if (eventsPayload[i].eventId == response.event.eventId) {
        eventsPayload[i] = response.event;
        break;
      }
    }

    return {
      status: 201,
      eventId: response.eventId,
    };
  },
  // FUNCTIONS //

  // Reset timestamp
  eventsTimestampReset(context) {
    context.commit("eventsTimestampReset");
  },
};
